"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _popupConfig = require("@/api/popup/popupConfig.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PlaceholderComponent',
  props: {
    title: {
      type: String,
      default: '功能配置'
    },
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      imagePrefix: '',
      id: null,
      // 预览弹窗相关
      previewVisible: false,
      previewImageUrl: '',
      formData: {
        imageUrl: ''
      }
    };
  },
  created: function created() {
    // 获取图片前缀
    this.getImagePrefix();
    // 页面加载时获取已保存的配置
    this.loadConfig();
  },
  methods: {
    // 确认保存
    confirmSave: function confirmSave() {
      var _this = this;
      this.$confirm('保存后将替换正在使用的配置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，执行保存操作
        _this.handleSave();
      }).catch(function () {
        // 用户点击取消，不执行任何操作
        _this.$message.info('已取消保存');
      });
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取图片前缀失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return url;
    },
    triggerSelect: function triggerSelect() {
      this.$refs.fileInput.click();
    },
    handleFileChange: function () {
      var _handleFileChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
        var file, loading, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = event.target.files && event.target.files[0];
              if (file) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              if (this.validateImage(file)) {
                _context2.next = 2;
                break;
              }
              event.target.value = '';
              return _context2.abrupt("return");
            case 2:
              // 显示上传loading
              loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用uploadPopupImage接口上传图片
              _context2.prev = 3;
              _context2.next = 4;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 4:
              response = _context2.sent;
              loading.close();
              if (response.code === 200 && response.data) {
                this.formData.imageUrl = response.data;
                this.$message.success('图片上传成功');
              } else {
                this.$message.error(response.message || '图片上传失败');
              }
              _context2.next = 6;
              break;
            case 5:
              _context2.prev = 5;
              _t2 = _context2["catch"](3);
              loading.close();
              console.error('图片上传失败:', _t2);
              this.$message.error('图片上传失败: ' + (_t2.message || '未知错误'));
            case 6:
              // 允许重复选择同一文件
              event.target.value = '';
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function handleFileChange(_x) {
        return _handleFileChange.apply(this, arguments);
      }
      return handleFileChange;
    }(),
    validateImage: function validateImage(file) {
      var isImage = file.type && file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    removeImage: function removeImage() {
      var _this2 = this;
      this.$confirm('确定要移除这张图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.formData.imageUrl = '';
        _this2.$message.success('图片移除成功');
      }).catch(function () {
        // 用户取消删除操作
      });
    },
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data, _loading, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              data = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                configInfo: this.formData.imageUrl
              }; // 显示保存loading状态
              _loading = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口保存配置
              _context3.next = 1;
              return (0, _decorateConfig.saveDecorateConfig)(data);
            case 1:
              response = _context3.sent;
              // 关闭loading
              _loading.close();
              if (!(response.code === 200)) {
                _context3.next = 3;
                break;
              }
              this.$message.success('配置保存成功');
              // 保存成功后更新ID
              if (response.data && response.data.id) {
                this.id = response.data.id;
              }
              // 保存成功后重新加载配置
              _context3.next = 2;
              return this.loadConfig();
            case 2:
              _context3.next = 4;
              break;
            case 3:
              this.$message.error(response.message || '保存失败!');
            case 4:
              _context3.next = 6;
              break;
            case 5:
              _context3.prev = 5;
              _t3 = _context3["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('保存失败:', _t3);
              this.$message.error('保存失败: ' + (_t3.message || '未知错误'));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 5]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 预览配置
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var configInfo, _loading2, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              configInfo = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                previewConfigInfo: this.formData.imageUrl
              }; // 显示预览loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '预览中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口预览配置
              _context4.next = 1;
              return (0, _decorateConfig.previewDecorateConfigInfo)(configInfo, this.xcxType);
            case 1:
              response = _context4.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  this.previewImageUrl = response.data.image;
                  this.previewVisible = true;
                } else {
                  this.$message.success('配置预览成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('预览失败:', _t4);
              this.$message.error('预览失败: ' + (_t4.message || '未知错误'));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function handlePreview() {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _loading3, response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return");
            case 1:
              // 显示加载loading状态
              _loading3 = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口获取配置
              _context5.next = 2;
              return (0, _decorateConfig.getDecorateConfig)(this.pageKey, this.moduleKey);
            case 2:
              response = _context5.sent;
              // 关闭loading
              _loading3.close();
              if (response.code === 200 && response.data) {
                // 保存ID
                this.id = response.data.id;

                // 解析配置信息
                this.formData.imageUrl = response.data.configInfo;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              // 如果response.data为空，说明还没有保存过配置，使用默认值
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('配置加载失败:', _t5);
              this.$message.error('配置加载失败: ' + (_t5.message || '未知错误'));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }()
  }
};